export function toggleFlag(value) {
  return !value;
}

export function setMapEntry(map, key, value) {
  return {
    ...map,
    [key]: value,
  };
}

export function markIds(map, ids, status) {
  const next = { ...map };
  for (const id of ids) {
    next[id] = status;
  }
  return next;
}

export function withTabFilters(listFilters, tab, filters) {
  return {
    ...listFilters,
    [tab]: filters,
  };
}

export function applySelectMandateSelection(
  selected,
  selectedAll,
  documentsData,
  itemId,
  item,
  isChecked,
) {
  const previousSelected = { ...selected };
  let isSelectedAll = selectedAll;

  if (item === 'all') {
    isSelectedAll = isChecked;
    if (isChecked) {
      documentsData.forEach((doc) => {
        previousSelected[doc.id] = doc;
      });
    } else {
      documentsData.forEach((doc) => {
        delete previousSelected[doc.id];
      });
    }
  } else if (isChecked) {
    previousSelected[itemId] = item;
    isSelectedAll = Object.keys(previousSelected).length === documentsData.length;
  } else {
    delete previousSelected[itemId];
    isSelectedAll = Object.keys(previousSelected).length === documentsData.length;
  }

  return { selected: previousSelected, selectedAll: isSelectedAll };
}

export function applyTransferenceSelection(
  transferenceSelected,
  id,
  item,
  isSelected,
  tab,
) {
  const next = { ...transferenceSelected };
  let transferWithErrorObject = null;
  let transferWithErrorId = null;

  if (isSelected) {
    if (tab === 'forSend' && item.usada_regcivil_pdf) {
      transferWithErrorObject = item;
      transferWithErrorId = id;
    }
    next[id] = item;
  } else {
    delete next[id];
  }

  return {
    transferenceSelected: next,
    transferWithErrorObject,
    transferWithErrorId,
  };
}

export function confirmUsedTransferSelection(
  transferenceSelected,
  transferWithErrorId,
  transferWithErrorObject,
) {
  return {
    transferenceSelected: {
      ...transferenceSelected,
      [transferWithErrorId]: transferWithErrorObject,
    },
    transferWithErrorObject: null,
    transferWithErrorId: null,
  };
}

export function cancelUsedTransferSelection(
  transferenceSelected,
  transferWithErrorId,
) {
  const next = { ...transferenceSelected };
  delete next[transferWithErrorId];
  return {
    transferenceSelected: next,
    transferWithErrorObject: null,
    transferWithErrorId: null,
  };
}

export function resetTransferenceProgressFlags(transferenceSelected) {
  const next = { ...transferenceSelected };
  for (const transferenceID of Object.keys(next)) {
    if (next[transferenceID].success) {
      delete next[transferenceID];
    } else {
      const entry = { ...next[transferenceID] };
      delete entry.success;
      delete entry.message;
      delete entry.inProgress;
      next[transferenceID] = entry;
    }
  }
  return next;
}
